import { useTranslation } from 'react-i18next';
import './style.css';
import DatePickerC from '@/components/formFields/DatePicker';
import IncludedYourPackage from '../includedYourPackage';

const QuotationDetails = ({ data, onChange }) => {
    const { t } = useTranslation();

    const handleIncludedItemToggle = (item) => {
        const current = data.includedInPackage || [];
        const newItems = current.includes(item)
            ? current.filter(i => i !== item)
            : [...current, item];
        onChange('includedInPackage', newItems);
    };


    return (
        <div className="quotation-details-section">
            <h2 className="quotation-section-title">{t('quotation-details')}</h2>

            {/* Proposed Treatment Description */}
            <div className="quotation-form-group">
                <label className="quotation-form-label">{t('proposed-treatment-description')}</label>
                <textarea
                    className="quotation-textarea"
                    rows="4"
                    placeholder={t('enter-detailed-clinical-description')}
                    value={data.proposedTreatmentDescription}
                    onChange={(e) => onChange('proposedTreatmentDescription', e.target.value)}
                />
            </div>

            <DatePickerC
                className="col-md-12 my-4 p-0"
                isRequired={false}
                name="proposedInpatientDateRange"
                formHandler={{ formValues: { proposedInpatientDateRange: data.proposedInpatientDateRange }, handleFormValues: onChange }}
            />


            <IncludedYourPackage
                addOns={data.includedInPackage}
                onAdd={(item) => handleIncludedItemToggle(item)}
                onRemove={(item) => handleIncludedItemToggle(item)}
            />

            {/* Expected Length of Stay & Base Quotation Price */}
            <div className="quotation-form-row">
                <div className="quotation-form-group quotation-form-group-half">
                    <label className="quotation-form-label">{t('expected-length-of-stay')}</label>
                    <div className="quotation-duration-inputs">
                        <div className="quotation-duration-input-group">
                            <input
                                type="number"
                                min="0"
                                placeholder={t('enter-expected-length-of-stay')}
                                className="quotation-input"
                                value={data.expectedLengthOfStay.days}
                                onChange={(e) => onChange('expectedLengthOfStay', {
                                    ...data.expectedLengthOfStay,
                                    days: e.target.value
                                })}
                            />
                            <span className="quotation-duration-label">{t('days')}</span>
                        </div>
                    </div>
                </div>

                <div className="quotation-form-group quotation-form-group-half">
                    <label className="quotation-form-label">{t('base-quotation-price')}</label>
                    <div className="quotation-price-input-group">
                        <span className="quotation-currency-symbol">$</span>
                        <input
                            type="number"
                            min="0"
                            step="0.01"
                            placeholder={t('enter-base-quotation-price')}
                            className="quotation-input quotation-price-input"
                            value={data.baseQuotationPrice}
                            onChange={(e) => onChange('baseQuotationPrice', e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuotationDetails;

